import styled from 'styled-components';
import { Button } from '@m/alchemy-ui/Button';
import { Checkbox } from '@m/alchemy-ui/Checkbox';
import { Field } from '@m/alchemy-ui/Field';
import { Input } from '@m/alchemy-ui/Input';
import { color, typeStyle, units } from '@m/alchemy-ui/theme';

/**
 * Styled-component overrides for the login form.
 * Uses alchemy theme tokens so dynamic community colours are respected.
 */

export const FormContainer = styled.div`
  width: 100%;

  @media (min-width: 800px) {
    max-width: 358px;
  }
`;

export const FormTitle = styled.h3`
  ${typeStyle('subHeaderM')};
  margin-bottom: ${units(2)};
`;

export const StyledField = styled(Field)`
  margin-bottom: ${units(2.5)};
  label {
    font-size: 14px;
    font-weight: 400;
    color: #1b2437;
  }
`;

export const StyledInput = styled(Input)``;

export const StyledCheckbox = styled(Checkbox)`
  margin-top: ${units(0.5)};
`;

export const ErrorAlert = styled.div.attrs({ className: 'mdl-alert -error' })``;

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${units(2.5)};
  padding: ${units(2)} 0;
  border-top: 1px solid ${color('line')};

  @media (max-width: 400px) {
    flex-direction: column;
    padding: 0;

    & > * {
      margin: 0;
      width: 100%;
      padding: ${units(1.25)} 0;
    }
  }
`;

export const ForgotPasswordLink = styled.a`
  margin-right: auto;
  ${typeStyle('bodyS')};
  color: ${color('typeLink', { palette: 'structural' })};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const SubmitButton = styled(Button)``;
